import React, { Fragment } from "react";
import styled, { css } from "styled-components";
import i18n from "i18next";
import { useSelector } from "react-redux";

import { isiOS, currentLockModeSelector, isMobile } from "@kubera/common";

import RadioButton from "components/inputs/RadioButton";
import LockSwitchComponent from "components/header/LockSwitchComponent";

const isMobileDevice = isMobile();
const Container = isMobileDevice
  ? styled.div``
  : styled.div`
      padding-bottom: 38px;
      margin-bottom: 26px;
      border-bottom: ${({ hideBorder }) => (!hideBorder ? "2px solid rgba(0, 0, 0, 0.1)" : null)};
    `;

const SelectTitle = styled.div`
  font-weight: bold;
  font-size: 22px;
  line-height: 130%;
  margin-bottom: 17px;
  ${isMobileDevice
    ? css``
    : css`
        margin-top: 4px;
      `};
`;

const SelectDesc = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 13px;
  line-height: 140%;
  letter-spacing: 0%;
  color: #000000cc;
  margin-top: -16px;
  ${isMobileDevice
    ? css`
        margin-bottom: 10px;
      `
    : css`
        margin-bottom: 20px;
      `};
`;

const RadioOption = styled(RadioButton)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  div {
    font-size: 16px;
    line-height: 150%;
  }

  path {
    fill: ${props => props.theme.mobileTxtColorOverlay};
  }

  ${isMobileDevice
    ? css`
    border: ${props => `1px solid ${props.theme.mobileBorderSeperatorColor}`};
    border-bottom: ${props => (!props.isLastItem ? 0 : null)}
    height: 55px;
    padding: 15px 15px 15px 0;
    flex-direction: row-reverse;
  `
    : css`
        margin-top: 22px;
        height: 24px;

        svg {
          transform: translateY(-1px);
        }
      `};
`;

const isiOSDevice = isiOS();

const i18nSuffix = isMobileDevice ? "" : "Desktop";
const AppLockSettingsComponent = () => {
  const lockMode = useSelector(currentLockModeSelector);

  return (
    <Container>
      <SelectTitle>{i18n.t("sidebar.appLock" + i18nSuffix).replace("%s%", isiOSDevice ? "iPad" : "Tab")}</SelectTitle>
      <SelectDesc>{i18n.t(`sidebar.appLock.description.${isiOSDevice ? "ios" : "notios"}`)}</SelectDesc>
      <LockSwitchComponent mode="default">
        <RadioOption label={i18n.t("off")} value="default" checked={lockMode === "default"} onChange={() => {}} />
      </LockSwitchComponent>
      <LockSwitchComponent mode="immediately">
        <RadioOption
          label={i18n.t("lock.immediately" + i18nSuffix)}
          value="immediately"
          checked={lockMode === "immediately"}
          onChange={() => {}}
        />
      </LockSwitchComponent>
      <LockSwitchComponent mode="1">
        <RadioOption
          label={i18n.t("lock.1min" + i18nSuffix)}
          value="1"
          checked={lockMode === "1"}
          onChange={() => {}}
        />
      </LockSwitchComponent>
      <LockSwitchComponent mode="15">
        <RadioOption
          label={i18n.t("lock.15min" + i18nSuffix)}
          value="15"
          checked={lockMode === "15"}
          onChange={() => {}}
        />
      </LockSwitchComponent>
      <LockSwitchComponent mode="30">
        <RadioOption
          label={i18n.t("lock.30min" + i18nSuffix)}
          value="30"
          checked={lockMode === "30"}
          onChange={() => {}}
          isLastItem
        />
      </LockSwitchComponent>
    </Container>
  );
};

export default AppLockSettingsComponent;
